<template>
    <div
        class="cierra-bot-header ctw-bg-white6 ctw-px-4 ctw-py-6 ctw-flex ctw-justify-between ctw-items-center ctw-border ctw-border-solid ctw-border-white6 md:ctw-rounded-t-xl">
        <span class="ctw-text-white ctw-font-medium">{{ name }}</span>
        <div class="ctw-flex ctw-items-center">
            <button class="ctw-p-0" @click="newConversation">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.5">
                        <path
                            d="M3.33333 3.33337V7.50004H3.81793M16.6151 9.16671C16.205 5.87811 13.3997 3.33337 9.99999 3.33337C7.20218 3.33337 4.8069 5.05685 3.81793 7.50004M3.81793 7.50004H7.49999M16.6667 16.6667V12.5H16.1821M16.1821 12.5C15.1931 14.9432 12.7978 16.6667 9.99999 16.6667C6.60031 16.6667 3.79499 14.122 3.38491 10.8334M16.1821 12.5H12.5"
                            stroke="#FFFEFD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                </svg>
            </button>
            <button @click="closeChat" class="ctw-p-0 ctw-ml-4">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.5">
                        <path d="M5 15L15 5M5 5L15 15" stroke="#FFFEFD" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </g>
                </svg>
            </button>
        </div>
    </div>
</template>

<script setup>
import { useConversationStore } from '@/store/conversation';
import { useWidgetStore } from '@/store/widget';
import { computed } from 'vue';

const widgetStore = useWidgetStore();
const conversationStore = useConversationStore();

const name = computed(() => widgetStore.bot.name);

const closeChat = () => {
    widgetStore.closeChat();
}

const newConversation = () => {
    conversationStore.newConversation();
}
</script>